<div class="d-flex flex-column flex-lg-row align-items-baseline pb-lg-3">
  <!-- TYPE D'OFFRES -->
  <section class="col-12 col-lg-6 mb-4 pb-4 m-lg-0 p-lg-0">
    <h4 class="text_4 mb-4 d-flex align-items-center">
      {{ 'PROCESSES.ACCOMMODATION.LIST.OFFER_TYPE' | translate }}
    </h4>
    <div class="d-flex gap-16 flex-wrap">
      <mat-checkbox *ngFor="let type of ['room', 'apartment']" class="w-fit-content px-0 text_2"
        [checked]="filters['type'].includes(type)" (change)="updateFilters('type',type)">
        {{ ('PROCESSES.ACCOMMODATION.LIST.' + type.toUpperCase()) | translate }}
      </mat-checkbox>
    </div>
  </section>

  <!-- PRIX -->
  <div class="col-12 col-lg-6 mb-4 pb-4 m-lg-0 p-lg-0">
    <h6 class="text_4 mb-4">{{ 'PROCESSES.ACCOMMODATION.LIST.FILTER_PRICE' | translate }}</h6>

    <div class="col-12 row mx-0 justify-content-between">

      <div class="col-12 col-lg-6 p-0 m-0 pe-lg-2 pt-4 pb-2 pb-lg-0 position-relative">
        <label class="subtitle_2 rescale form-label-color text-black" for="minimum_price">
          {{'COMMON.MINIMUM' | translate}}
          <span class="subtitle_2 fst-italic" *ngIf="rangeLimits && rangeLimits.minPrice">{{ '(' + rangeLimits.minPrice + ' €)'  }}</span>
        </label>
        <div class="form_inputs px-2 py-1 d-flex ">
          <input numberOnly [(ngModel)]="filters.minPrice" (ngModelChange)="sendChanges()"
            class="w-100 border-0 minitext_3"
            id="minimum_price"
            min="0" placeholder="{{'COMMON.MINIMUM' | translate}}" size="5"
            type="number">
          <div class="input-prefix text_2 ps-2 pe-1 border-opacity-50">€</div>
        </div>
      </div>


      <div class="col-12 col-lg-6 p-0 m-0 ps-lg-2 pt-4 position-relative">
        <label class="subtitle_2 rescale form-label-color text-black ps-lg-2" for="maximum_price">
          {{'COMMON.MAXIMUM' | translate}}
          <span class="subtitle_2 fst-italic" *ngIf="rangeLimits && rangeLimits.maxPrice">{{ '(' + rangeLimits.maxPrice + ' €)'  }}</span>
        </label>
        <div class="form_inputs px-2 py-1 d-flex">
          <input numberOnly [(ngModel)]="filters.maxPrice" (ngModelChange)="sendChanges()"
            class="w-100 border-0 minitext_3"
            id="maximum_price"
            min="{{filters.minPrice}}"
            placeholder="{{'COMMON.MAXIMUM' | translate}}" size="5" type="number">
          <div class="input-prefix text_2 ps-2 pe-1 border-opacity-50">€</div>
        </div>
      </div>
    </div>

  </div>

</div>

<div class="d-flex flex-column flex-lg-row align-items-baseline mb-4 pt-lg-4 ">
  <!-- RENT DURATION OU DATE D'ARRIVEE/DEPART -->
  <div class="col-12 col-lg-6 mb-4 pb-4 m-lg-0 p-lg-0">
    <h4 class="text_4 mb-4">
      {{ 'PROCESSES.ACCOMMODATION.LIST.RENT_DURATION' | translate }}
      <span class="title_3 txt-dark-blue" *ngIf="type === 'alert' && filters.durationDate">
        : {{ 'PROCESSES.ACCOMMODATION.LIST.RENT_DURATION_RANGE' | translate:{'value': filters.durationDate}  }}
      </span>
    </h4>
    <div class="d-flex gap-16 flex-wrap" *ngIf="type === 'filter'">
      <mat-checkbox *ngFor="let duration of ['30_60' ,'60_180', '180_365','365']; trackBy:trackByIndex" class="w-fit-content px-0 text_2"
        [checked]="filters['duration'].includes(duration)" (change)="updateFilters('duration', duration)">
        {{ ('PROCESSES.ACCOMMODATION.LIST.' + duration + '_MONTHS') | translate }}
      </mat-checkbox>
    </div>

    <div class="d-flex flex-column flex-sm-row gap-4 pt-4" *ngIf="type === 'alert'">
      <div class="position-relative  col-12 col-sm-5">
        <span class="subtitle_2 rescale form-label-color text-black">
          {{'PROCESSES.ACCOMMODATION.LIST.DATE_PICKER.START_DATE' | translate}}
        </span>
        <mat-form-field class="select_button w-100">
          <mat-select [(ngModel)]="filters.arrivalDate" (ngModelChange)="selectDate(filters.arrivalDate)" [disableOptionCentering]="false">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let arrivalDate of arrivalArray; trackBy:trackByIndex" [value]="arrivalDate">
              {{ arrivalDate | date:'MMMM YYYY':'':locale }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="position-relative col-12 col-sm-5">
        <span class="subtitle_2 rescale form-label-color text-black">
          {{'PROCESSES.ACCOMMODATION.LIST.DATE_PICKER.END_DATE' | translate}}
        </span>

        <mat-form-field class="select_button w-100">
          <mat-select [(ngModel)]="filters.departureDate" (ngModelChange)="selectDate(filters.departureDate)" [disableOptionCentering]="false">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let departureDate of departureArray; trackBy:trackByIndex" [value]="departureDate">
              {{ departureDate | date:'MMMM YYYY':'':locale }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

  </div>

  <!-- SURFACE -->
  <div class="col-12 col-lg-6 m-0 p-0" [ngClass]="{'mb-4 pb-4 m-lg-0 p-lg-0': type == 'filter'}">
    <h6 class="text_4 mb-4">{{ 'PROCESSES.ACCOMMODATION.LIST.FILTER_AREA_SIZE' | translate }}</h6>

    <div class="col-12 row mx-0 justify-content-between">

      <div class="col-12 col-lg-6 px-0 m-0 pe-lg-2 pt-4 pb-2 pb-lg-0 position-relative">
        <label class="subtitle_2 rescale form-label-color text-black" for="minimum_surface">
          {{'COMMON.MINIMUM' | translate}}
        </label>
        <div class="form_inputs px-2 py-1 d-flex ">
          <input numberOnly [(ngModel)]="filters.minMeter" (ngModelChange)="sendChanges()"
            class="w-100 border-0 minitext_3"
            id="minimum_surface"
            min="0" placeholder="{{'COMMON.MINIMUM' | translate}}" size="5"
            type="number">
          <div class="input-prefix text_2 ps-2 border-opacity-50">m²</div>
        </div>
      </div>


      <div class="col-12 col-lg-6 p-0 m-0 ps-lg-2 pt-4 position-relative">
        <label class="subtitle_2 rescale form-label-color text-black ps-lg-2" for="maximum_surface">
          {{'COMMON.MAXIMUM' | translate}}
        </label>
        <div class="form_inputs px-2 py-1 d-flex">
          <input numberOnly [(ngModel)]="filters.maxMeter" (ngModelChange)="sendChanges()"
            class="w-100 border-0 minitext_3"
            id="maximum_surface"
            min="{{filters.minMeter}}"
            placeholder="{{'COMMON.MAXIMUM' | translate}}" size="5" type="number">
          <div class="input-prefix text_2 ps-2 border-opacity-50">m²</div>
        </div>
      </div>
    </div>

  </div>

</div>
@if (type === 'filter') {
  <div class="d-flex flex-column flex-lg-row align-items-baseline mb-lg-5 pt-lg-4 border-top" >
    <!-- badges -->
    <div class="col-12 mb-4 pb-4 m-lg-0 p-lg-0">
      <h4 class="text_4 mb-4">
        {{ 'PROCESSES.ACCOMMODATION.LIST.BADGES' | translate }}
      </h4>

      <!-- Checkboxes avec badges -->
      <div class="d-flex flex-column flex-lg-row gap-2 gap-lg-5" >

        <!-- Badge Localisation -->
        <div class="d-flex align-items-center gap-1">
          <mat-checkbox
            class="w-fit-content px-0 text_2"
            [checked]="filters.selectedBadge === 'isLocated'"
            (change)="updateBadge('isLocated')">
          </mat-checkbox>
          <app-item-badges
            [element]="{ badges: { isLocated: 1 } }"
            [icon]="'Localisation'"
            [textKey]="'COMMON.GOOD_LOCALISATION'"
            [backgroundClass]="'bg-grad-blue'">
          </app-item-badges>
        </div>

        <!-- Badge Populaire -->
        <div class="d-flex align-items-center gap-1">
          <mat-checkbox
            class="w-fit-content px-0 text_2"
            [checked]="filters.selectedBadge === 'isPopular'"
            (change)="updateBadge('isPopular')">
          </mat-checkbox>
          <app-item-badges
            [element]="{ badges: { isPopular: 1 } }"
            [icon]="'Stars'"
            [textKey]="'COMMON.IS_POPULAR'"
            [backgroundClass]="'bg-grad-blue'">
          </app-item-badges>
        </div>

        <!-- Badge Promotion -->
        <div class="d-flex align-items-center gap-1">
          <mat-checkbox
            class="w-fit-content px-0 text_2"
            [checked]="filters.selectedBadge === 'isPromoted'"
            (change)="updateBadge('isPromoted')">
          </mat-checkbox>
          <app-item-badges
            [element]="{ badges: { isPromoted: 1 } }"
            [icon]="'Promotion'"
            [textKey]="'COMMON.IN_PROMOTION'"
            [backgroundClass]="'bg-grad-red'">
          </app-item-badges>
        </div>
      </div>

    </div>
  </div>
}



  <div class="d-flex flex-column flex-lg-row align-items-baseline mb-lg-5 pt-4 border-top">
    <!-- TENANTS MAX NUMBER -->
    <div class="col-12 col-lg-6 pb-4 m-0 p-lg-0">
      <div class="text_4 pb-4" [ngClass]="{'mediumGray':filters.type.includes('apartment')}">
        {{ 'PROCESSES.ACCOMMODATION.LIST.FILTER_ROOM_MAX_ROOMATES' | translate }}
      </div>
      <div class="d-flex gap-16 flex-wrap">
        <mat-checkbox [disabled]="filters.type.includes('apartment')" *ngFor="let tenants of ['small' ,'big']" class="w-fit-content px-0 text_2"
          [checked]="filters['tenants'].includes(tenants)" (change)="updateFilters('tenants',tenants)">
          <div>{{'PROCESSES.ACCOMMODATION.LIST.TYPE_COLOCATION.' + tenants.toUpperCase() | translate}}</div>
          <div class="minitext_1">
            ({{ tenants === 'small' ? ' 2-5 ' : ' 5+ '}} {{ 'COMMON.ROOMATES' | translate }})
          </div>
        </mat-checkbox>
      </div>
    </div>
    <!-- TOILET/BATHROOM -->
    <div class="col-12 col-lg-6 pb-4 m-0 p-lg-0">
      <div class="text_4 pb-4" [ngClass]="{'mediumGray':filters.type.includes('apartment')}">{{ 'PROCESSES.ACCOMMODATION.HOUSE_SPECIFICITY' | translate }}</div>
      <div class="row m-0 p-0 flex-wrap gap-16">
        <mat-checkbox [disabled]="filters.type.includes('apartment')" *ngFor="let amenity of ['PRIVATE_BATHROOM' ,'PRIVATE_WC']"
          [(ngModel)]="filters[amenity === 'PRIVATE_BATHROOM' ? 'bathrooms' : 'wc']"
          (ngModelChange)="sendChanges()"
          [ngClass]="{'fw-bold' : filters[amenity === 'PRIVATE_BATHROOM' ? 'bathrooms' : 'wc'] == true}"
          class="w-fit-content px-0 text_2">
          {{ ('PROCESSES.ACCOMMODATION.LIST.' + amenity) | translate }}
        </mat-checkbox>
        <mat-checkbox [disabled]="filters.type.includes('apartment')"
          [(ngModel)]="filters.is_studentResidence"
          (ngModelChange)="sendChanges()"
          class="w-fit-content px-0 text_2">
          {{ 'PROCESSES.ACCOMMODATION.AMENITIES.STUDENT-RESIDENCE' | translate }}
      </mat-checkbox>
      </div>
    </div>

  </div>

  <div class="d-flex flex-column flex-lg-row align-items-baseline mb-lg-5">
    <!-- NB ROOMS -->
    <div class="col-12 col-lg-6 pb-4 m-0 p-lg-0">
      <h6 class="text_4 pb-4" [ngClass]="{'mediumGray':filters.type.includes('apartment')}">
        {{ 'PROCESSES.ACCOMMODATION.LIST.FILTER_ROOM_AVAILABLE_NUMBER' | translate }}
      </h6>
      <div class="d-flex gap-16 flex-wrap">
        <mat-checkbox [disabled]="filters.type.includes('apartment')" *ngFor="let empty_rooms of [1,2,3,4,5]" class="w-fit-content px-0 text_2"
          [checked]="filters['empty_rooms'].includes(empty_rooms) || filters['empty_rooms'].includes(empty_rooms.toString())" (change)="updateFilters('empty_rooms',empty_rooms)">
          {{empty_rooms === 5 ? empty_rooms + '+' : empty_rooms}}
        </mat-checkbox>
      </div>
    </div>

    <!-- GENDER MAJORITY -->
    <div class="col-12 col-lg-6 m-0 p-0">
      <h6 class="text_4 pb-4" [ngClass]="{'mediumGray':filters.type.includes('apartment')}">
        {{ 'PROCESSES.ACCOMMODATION.LIST.FILTER_ROOM_ROOMATES_GENDER' | translate }}
      </h6>
      <div class="d-flex gap-16 flex-wrap">
        <mat-checkbox [disabled]="filters.type.includes('apartment')" *ngFor="let tenants_gender of ['men', 'women', 'mix']" class="w-fit-content px-0 text_2"
          [checked]="filters['tenants_gender'].includes(tenants_gender)" (change)="updateFilters('tenants_gender',tenants_gender)">
          {{ 'PROCESSES.ACCOMMODATION.LIST.FILTER_ROOM_ROOMATES_GENDER_' + tenants_gender.toUpperCase() | translate }}
        </mat-checkbox>
      </div>
    </div>
  </div>
